import Marquee from 'react-fast-marquee';

const DEFAULT_ITEMS = [
  'Section 6 · Consent',
  '72-Hour Breach Clock',
  'Data Protection Board of India',
  '13 May 2027 Deadline',
  '₹250 Crore Maximum Penalty',
  'Significant Data Fiduciary',
  'Consent Manager',
  '44 Sections · 9 Chapters',
];

export const EditorialMarquee = ({ items = DEFAULT_ITEMS }) => (
  <div data-testid="editorial-marquee" className="border-y border-white/10 bg-navy py-6 overflow-hidden">
    <Marquee speed={28} gradient={false}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-2xl sm:text-3xl text-white/90 mx-8 whitespace-nowrap">{item}</span>
          <span className="text-saffron text-2xl mx-2">✺</span>
        </span>
      ))}
    </Marquee>
  </div>
);
